const subscriptionStatusBadgeType = (status: string) => {
  switch (status) {
    case 'active':
      return 'success';
    case 'inactive':
      return 'alert';
    case 'pending':
      return 'information';
    case 'paused':
      return 'warning';
    default:
      return 'warning';
  }
};

export default subscriptionStatusBadgeType;
